import {jsonMember, jsonObject} from "typedjson";


@jsonObject
export class PitFilterValue {
  @jsonMember({name: "valueInt", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _valueInt: number;

  @jsonMember({name: "valueDouble", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _valueDouble: number;

  @jsonMember({name: "valueDate", constructor: String, emitDefaultValue: false, isRequired: false })
  private _valueDate: string;

  @jsonMember({name: "valueBoolean", constructor: Boolean, emitDefaultValue: false, isRequired: false })
  private _valueBoolean: boolean;

  @jsonMember({name: "valueString", constructor: String, emitDefaultValue: false, isRequired: false })
  private _valueString: string;

  get valueInt(): number {
    return this._valueInt;
  }

  set valueInt(value: number) {
    this._valueInt = value;
  }

  get valueDouble(): number {
    return this._valueDouble;
  }

  set valueDouble(value: number) {
    this._valueDouble = value;
  }

  get valueDate(): string {
    return this._valueDate;
  }

  set valueDate(value: string) {
    this._valueDate = value;
  }

  get valueBoolean(): boolean {
    return this._valueBoolean;
  }

  set valueBoolean(value: boolean) {
    this._valueBoolean = value;
  }

  get valueString(): string {
    return this._valueString;
  }

  set valueString(value: string) {
    this._valueString = value;
  }
}
